import { useState, useEffect } from 'react';
import { categories, evidenceTypes } from '@/mocks/cases';

type Props = {
  keyword: string;
  category: string;
  evidence: string;
  onKeyword: (value: string) => void;
  onCategory: (value: string) => void;
  onEvidence: (value: string) => void;
};

export default function CaseFilters({ keyword, category, evidence, onKeyword, onCategory, onEvidence }: Props) {
  const [input, setInput] = useState(keyword);

  useEffect(() => {
    setInput(keyword);
  }, [keyword]);

  function submitSearch(e: React.FormEvent) {
    e.preventDefault();
    onKeyword(input.trim());
  }

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <form onSubmit={submitSearch} className="flex flex-col gap-3 sm:flex-row">
        <div className="flex flex-1 items-center rounded-md border border-background-300 bg-background-100 px-3 focus-within:border-primary-400">
          <i className="ri-search-line text-sm text-foreground-500"></i>
          <input
            type="search"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="输入关键词，如：分成 / 录音 / 转账"
            aria-label="搜索爆料关键词"
            className="w-full bg-transparent px-2 py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
          />
        </div>
        <button
          type="submit"
          className="whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
        >
          搜索爆料
        </button>
      </form>

      <div className="mt-4">
        <p className="text-xs font-medium text-foreground-500">主题分类</p>
        <div className="mt-2 flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => onCategory('all')}
            aria-pressed={category === 'all'}
            className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-sm transition-colors ${
              category === 'all'
                ? 'bg-primary-600 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            全部主题
          </button>
          {categories.map((cat) => (
            <button
              key={cat.id}
              type="button"
              onClick={() => onCategory(cat.id)}
              aria-pressed={category === cat.id}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-sm transition-colors ${
                category === cat.id
                  ? 'bg-primary-600 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-4">
        <p className="text-xs font-medium text-foreground-500">证据类型</p>
        <div className="mt-2 flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => onEvidence('all')}
            aria-pressed={evidence === 'all'}
            className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-sm transition-colors ${
              evidence === 'all'
                ? 'bg-accent-500 text-foreground-950'
                : 'bg-accent-100 text-accent-900 hover:bg-accent-200'
            }`}
          >
            不限形式
          </button>
          {evidenceTypes.map((type) => (
            <button
              key={type.key}
              type="button"
              onClick={() => onEvidence(type.key)}
              aria-pressed={evidence === type.key}
              className={`flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full px-3 py-1.5 text-sm transition-colors ${
                evidence === type.key
                  ? 'bg-accent-500 text-foreground-950'
                  : 'bg-accent-100 text-accent-900 hover:bg-accent-200'
              }`}
            >
              <i className={type.icon}></i>
              {type.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}